import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';

import styles from './Card.module.css';

type CardVariant = 'standard' | 'interactive' | 'metric' | 'elevated';

type CardProps<T extends ElementType = 'div'> = {
  as?: T;
  children: ReactNode;
  className?: string;
  variant?: CardVariant;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children' | 'className'>;

function classNames(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(' ');
}

export function Card<T extends ElementType = 'div'>({
  as,
  children,
  className,
  variant = 'standard',
  ...rest
}: CardProps<T>) {
  const Component = as ?? 'div';

  return (
    <Component className={classNames(styles.card, className)} data-variant={variant} {...rest}>
      {children}
    </Component>
  );
}
